import React, { useState, useEffect } from 'react';
import { colors } from '../styles/colors';
import { fonts, fontWeights } from '../styles/fonts';
import { content } from '../constants/content';

function Applications() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return (
    <section id="applications" style={isMobile ? styles.sectionMobile : styles.section}>
      <h2 style={isMobile ? styles.titleMobile : styles.title}>
        {content.applications.title}
      </h2>
      
      <div style={isMobile ? styles.gridMobile : styles.grid}>
        {content.applications.items.map((item, index) => (
          <div key={index} style={isMobile ? styles.cardMobile : styles.card}>
            <h3 style={isMobile ? styles.cardTitleMobile : styles.cardTitle}>
              {item.title}
            </h3>
            <p style={isMobile ? styles.cardDescriptionMobile : styles.cardDescription}>
              {item.description}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}

const styles = {
  section: {
    padding: '80px 60px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  sectionMobile: {
    padding: '40px 20px',
    backgroundColor: colors.white,
    textAlign: 'center',
  },
  title: {
    fontSize: '48px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '60px',
  },
  titleMobile: {
    fontSize: '32px',
    fontWeight: fontWeights.bold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '40px',
    lineHeight: '1.2',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '30px',
    maxWidth: '1200px',
    margin: '0 auto',
  },
  gridMobile: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    maxWidth: '100%',
    margin: '0 auto',
  },
  card: {
    padding: '40px 30px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'left',
  },
  cardMobile: {
    padding: '25px 20px',
    backgroundColor: colors.white,
    border: `2px solid ${colors.primary}`,
    borderRadius: '12px',
    textAlign: 'left',
    width: '100%',
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '15px',
  },
  cardTitleMobile: {
    fontSize: '18px',
    fontWeight: fontWeights.semibold,
    fontFamily: fonts.primary,
    color: colors.textPrimary,
    marginBottom: '12px',
  },
  cardDescription: {
    fontSize: '16px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.6',
  },
  cardDescriptionMobile: {
    fontSize: '15px',
    fontWeight: fontWeights.regular,
    fontFamily: fonts.primary,
    color: colors.textSecondary,
    lineHeight: '1.5',
  },
};

export default Applications;